// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CountryRepoConfig from "./CountryRepoConfig.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";

function fetchCountryConfig(param) {
  var requestUrl = Config.Env.getHostName(undefined) + "/geo_region/config";
  return NetworkV2$Catalyst.get(requestUrl, undefined, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CountryRepoConfig.CountryResponseConverter.execute, result);
                        });
            });
}

var T = {
  fetchCountryConfig: fetchCountryConfig
};

export {
  T ,
  
}
/* Config Not a pure module */
